import { render, staticRenderFns } from "./ReportInappropriateList.vue?vue&type=template&id=2d19e3a8&scoped=true&"
import script from "./ReportInappropriateList.vue?vue&type=script&lang=js&"
export * from "./ReportInappropriateList.vue?vue&type=script&lang=js&"
import style0 from "./ReportInappropriateList.vue?vue&type=style&index=0&id=2d19e3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d19e3a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
